import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/dashboard-anomali"

class DashboardAnomaliService {
    getData(param) {
        let url=""
        if (param) {
            url = baseUrl + "" + param
        } else {
            url = baseUrl
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

    getDataGroup(param) {
        let url=""
        if (param) {
            url = baseUrl + "/group-by" + param
        } else {
            url = baseUrl+ "/group-by"
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

}

export default new DashboardAnomaliService();